import { updateUrl } from "@modules/util/url.ts"

export function getUrlParam(key: string, urlString: string): string {
    const url = new URL(urlString)
    const value = url.searchParams.get(key)
    if (value !== null) {
        return value
    }
    return ""
}

export function updatePartialUrlParam(partialUrl: string, key: string, value: string): string {
    const url = new URL(partialUrl, window.location.origin)

    url.searchParams.set(key, value)

    return url.pathname + (url.searchParams.toString() ? "?" + url.searchParams.toString() : "")
}

export function removePartialUrlParam(partialUrl: string, key: string): string {
    const url = new URL(partialUrl, window.location.origin)

    url.searchParams.delete(key)

    return url.pathname + (url.searchParams.toString() ? "?" + url.searchParams.toString() : "")
}

export function setUrlParamsToSpecificValue(
    updates: Record<string, string | null>,
    urlString: string = window.location.href,
) {
    const url = new URL(urlString)

    for (const [key, value] of Object.entries(updates)) {
        if (value === null) {
            url.searchParams.delete(key)
        } else {
            url.searchParams.set(key, value)
        }
    }

    updateUrl(url.toString())
}
